// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <div id="appeals" />
      <h1>Decision Reviews</h1>
      <h2 id="month-99%2C-2099">Month 99, 2099</h2>
      <p>(v3) These are dummy release notes.  Link to PRs here!</p>
      <hr />
    </div>
  );
};

export default MarkdownComponent;
